export default "__VITE_ASSET__ChT3t5WH__"